import { render, staticRenderFns } from "./TimelineLabel.vue?vue&type=template&id=1ca9739a&"
import script from "./TimelineLabel.vue?vue&type=script&lang=js&"
export * from "./TimelineLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports